import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt, faEdit, faMinusCircle, faQuestionCircle, faBars, faChevronUp, faChevronCircleUp, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import {
  loadPersonalStrategies,
  savePortfolioAsNewStrategy,
  showPersonalStrategy,
  showStrategyEditor,
  getBenchmarks,
} from '../../actions/data';
import './App.css';
import StrategyList from './StrategyList/StrategyList.js';

// Initialize the Font Awesome library
library.add(faTrashAlt, faEdit, faMinusCircle, faQuestionCircle, faBars, faChevronUp, faChevronCircleUp, faChevronRight, faChevronLeft);

// Split out the query params hash string into key/value pairs
function getQueryParams(hashString) {

  // Remove the app name
  const params = hashString.slice(1);

  // Get the params into key/value array
  const queryParams = params.reduce(function (map, obj) {

    const pair = obj.split('=');
    map[pair[0]] = pair[1];
    return map;
  }, {});

  return queryParams;
}

class App extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      portfolioToSave: null,
    }
  }


  componentDidMount() {
    this.props.loadPersonalStrategies();
    this.props.getBenchmarks();
    this.unlisten = this.listenForUrlChanges();
  }

  componentWillUnmount() {
    this.unlisten();
  }

  listenForUrlChanges() {

    const {
      history,
    } = this.props;

    const unlisten = history.listen(() => {

      // Get the hash and split it by '&'
      const hash = history.location.hash.substring(1).split('&');

      // If there is only the app name then ignore
      if (hash.length === 1) {
        return;
      }

      // Get the query params from the rest of the hash
      const queryParams = getQueryParams(hash);

      switch (hash[0]) {

        // Check for DPD requests
        case 'dpd':
        case 'portfolio-analysis':
          // Check if the saveToMyPortfolios flag has been added
          if (queryParams['saveToMyPortfolios'] && this.state.portfolioToSave !== queryParams['saveToMyPortfolios']) {
            this.setState({
              portfolioToSave: queryParams['saveToMyPortfolios'],
            })
            this.props.savePortfolioAsNewStrategy(
              queryParams['saveToMyPortfolios'],
              queryParams['portfolioName'] ? decodeURI(queryParams['portfolioName']) : undefined);
          }

          break;

        // Check for personal strategies requests
        case 'myportfolios':
        case 'my-portfolio-hub':
          // Check if the myPortfolioId flag has been added
          if (queryParams['myportfolioid']) {
            // Load the Personal Strategy directly
            const myPortfolioId = queryParams['myportfolioid']
            console.log('Loading MyPortfolio with id ' + myPortfolioId)
            this.props.showPersonalStrategy(myPortfolioId);
          } else if (queryParams['newstrategy']) {
            this.props.showStrategyEditor(null);
          }

          break;

        default:
      }

    });

    return unlisten;

  }

  render() {

    const { params } = this.props;
    return (
      <div className='app'>
        <div>
          <div className='top-of-app' id='personal-strategy-top-of-app'>
            <div className='version'>{'V' + params.version}</div>
          </div>
          <StrategyList />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    params: state.params,
    data: state.data,
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadPersonalStrategies,
    savePortfolioAsNewStrategy,
    showPersonalStrategy,
    showStrategyEditor,
    getBenchmarks,
  },
)(App));
